import { ReactNode, useState } from 'react';
import styled from '@emotion/styled';

import { Swiper, SwiperOptions, SwiperSlide } from '@common/carousel/swiper';
import { SWIPER_STYLE } from '@common/styles';

const options: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  resizeObserver: true,
};

interface SwiperSectionProps<Item> {
  isApp?: boolean;
  item_list: Item[];
  renderItem: (item: Item, index: number) => JSX.Element;
  lastChild?: ReactNode;
}

export function SwiperSection<Item>({ isApp = false, item_list, renderItem, lastChild }: SwiperSectionProps<Item>) {
  const [last, setLast] = useState(false);

  return (
    <Container last={last}>
      <Swiper
        {...options}
        onSlideChange={(swiper) => {
          isApp && (item_list.length - 1 === swiper.activeIndex ? setLast(true) : setLast(false));
        }}
      >
        {item_list.map((item, index) => (
          <SwiperSlide key={index}>{renderItem(item, index)}</SwiperSlide>
        ))}
        {lastChild && <SwiperSlide>{lastChild}</SwiperSlide>}
      </Swiper>
    </Container>
  );
}

const Container = styled.section<{ last: boolean }>`
  margin-top: 12px;
  margin-bottom: 16px;

  .swiper-horizontal {
    padding: 0 16px !important;
  }
  ${SWIPER_STYLE}
  .swiper-wrapper {
    .swiper-slide {
      width: auto;
      height: auto;
    }
  }

  .swiper {
    position: relative;
    ${({ last }) => last && 'left: -12% !important;'};
  }
`;
